export const FieldMaxLength = {
  LONG: 200,
}
